export const environment = {
  production: true,
  mode: 'dev'
};
